// 封装购物车相关接口
import request from '@/utils/http'
const AUTH_BASE_URL = "/api/v1";

// 加入购物车
export const insertCartAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/add_shop_cart`,
        method: 'POST',
        data
    })
}

// 获取最新的购物车列表
export const findNewCartListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/shop_cart_list`,
        method: 'GET',
        params
    })
}

// 删除购物车
export const delCartAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/del_cart`,
        method: 'POST',
        data
    })
}

// 合并购物车

export const mergeCartAPI = (data) => {
    return request({
        url: '/member/cart/merge',
        method: 'POST',
        data
    })
}